export default "__VITE_ASSET__C4O_rGD1__"